import React from "react";
import { Footprints } from "lucide-react";
import { PageHeader, SectionCard, EmptyState } from "../components/Common";
import { useAuth } from "../lib/auth";
import { Navigate } from "react-router-dom";

export default function Orthotics() {
  const { organization } = useAuth();
  const enabled = organization?.features?.orthotics;
  if (!enabled) return <Navigate to="/app" replace />;
  return (
    <div className="p-6 lg:p-8 space-y-6" data-testid="orthotics-page">
      <PageHeader
        title="Orthotics Clinic"
        subtitle={`Braces, prosthetics & gait aids · ${organization?.name || ""}`}
      />
      <SectionCard title="Orthotics workflow">
        <EmptyState
          icon={Footprints}
          title="Orthotics Clinic is live for this hospital"
          description="Enabled by the platform team for your account. Use this space to record assessments, casting, fittings and follow-up for orthotic braces, prosthetic limbs and mobility aids. Full workflows will be added as you request them."
        />
      </SectionCard>
    </div>
  );
}
